import React, {  Component } from 'react';

export default class governmentDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialogStatus(false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="estRetailPriceTooltip">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Disclaimer</h2>
                    <div>
                <p>General Electric Company accepts on-line ordering via this site from the 50 United States only. Products and pricing are subject to change without notice. Products are subject to availability.  Sales to minors via this site are prohibited; resale of products is prohibited; purchase quantity is limited. U.S. Government sales limited to equipment only and subject to General Electric Company Terms and Conditions.</p>        </div>
                 </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/governmentDialog.js